import log from 'loglevel';
function setLogLevel() {
    const input = process.env.LOG_LEVEL;
    const lower = input ? input.trim().toLowerCase() : '';
    let level;
    switch (lower) {
        case 'trace':
            level = 'trace';
            break;
        case 'debug':
            level = 'debug';
            break;
        case 'info':
            level = 'info';
            break;
        case 'warn':
            level = 'warn';
            break;
        case 'error':
            level = 'error';
            break;
        case 'silent':
            level = 'silent';
            break;
        default:
            level = 'warn';
            break;
    }
    log.setLevel(level, false);
    log.info(`wisepipe-log level=${level}`);
}
var LogLevel;
(function (LogLevel) {
    LogLevel["TRACE"] = "TRACE";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
setLogLevel();
export { log, LogLevel };
//# sourceMappingURL=log.js.map